export interface IEventRes {
    records: IEvent[];
    totalRecordCount: number;
}

export interface IEvent {
  eventId: number;
  isVisible: boolean;
  eventName: string;
  eventType: number | string;
  eventDateStart: string;
  eventDateEnd: string;
  eventLocation: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IEvent = {
  getDefault(): IEvent {
    return {
      eventId: 0,
      isVisible: false,
      eventName: '',
      eventType: '',
      eventDateStart: '',
      eventDateEnd: '',
      eventLocation: '',
    };
  },
};
